import TokensService from '@omni/kit/services/TokensService';

import BaseService, { IHttpResponse } from '../BaseService';
import { IPreparePlayerPromptUrl, preparePlayerPromptUrl } from './BuildUrls';
import { IPlayerPrompt } from './Types';

const debug = require('debug')('tca:service:PlayerPromptService');

interface IPlayerPromptGetAll extends IPreparePlayerPromptUrl {
  getFromCache?: boolean;
  appKey: string;
}

interface IPlayerPromptGetAllResponse extends IHttpResponse {
  body?: {
    _embedded: {
      'player-prompts': IPlayerPrompt[];
    };
  };
}

const getAll = async ({
  getFromCache,
  appKey,
  ...buildUrlProps
}: IPlayerPromptGetAll): Promise<IPlayerPromptGetAllResponse> => {
  debug('getAll');
  const url = preparePlayerPromptUrl(buildUrlProps);

  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    appKey,
    getFromCache,
    token: guestToken,
  });
};

export default {
  getAll,
};
